import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { VoucherType } from 'src/features/voucherTypes/utils/types';

const RESOURCE = '/discounts/voucher-type/:voucherTypeId/';

type QueryFnType = typeof queryFn;

interface DTO {
    voucherTypeId: string;
}
const queryFn = ({ voucherTypeId }: DTO): Promise<VoucherType> => {
    return axios.get(formatResourcePath(RESOURCE, { voucherTypeId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetVoucherType, RESOURCE as VOUCHER_TYPE_RESOURCE };
